import { Spin } from 'antd';

import { SubmitWrapper } from '@style/pages/form.style';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Input, InputPassword } from '@atom/form/input/input';
import { Label } from '@atom/form/label/label';
import { Text } from '@atom/typography/typography';
import { RouteEnum } from '@enum/route.enum';
import { ColorEnum } from '@enum/style/color.enum';
import { TestIdsEnum } from '@enum/test-ids.enum';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';
import { getTestId } from '@util/data/get-test-id';

import { initialLoginForm } from './login.form-initial';
import { ForgotLink } from './login.form-style';
import { loginFormValidation } from './login.form-validation';

export const LoginForm = ({ error, isLoading = false, form }: BaseFormInterface) => (
  <Form form={form} initialValues={initialLoginForm} layout='vertical' name='login'>
    <Label label='Email' name='email' rules={[loginFormValidation]}>
      <Input placeholder='Ex: name@company.com' {...getTestId(TestIdsEnum.LoginEmailInput)} />
    </Label>
    <Label label='Password' name='password' rules={[loginFormValidation]}>
      <InputPassword placeholder='Password' {...getTestId(TestIdsEnum.LoginPasswordInput)} />
    </Label>
    <ForgotLink href={RouteEnum.ForgotPassword.path} type={ButtonTypeEnum.Link}>
      <Text color={ColorEnum.Inherit} level='s'>
        Forgot your password?
      </Text>
    </ForgotLink>
    <SubmitWrapper>
      <Button htmlType='submit' type={ButtonTypeEnum.Primary} block {...getTestId(TestIdsEnum.LoginSubmitButton)}>
        {isLoading && <Spin />}
        {!isLoading && (
          <Text color={ColorEnum.Inherit} letterSpacing={1.4}>
            LOGIN
          </Text>
        )}
      </Button>
    </SubmitWrapper>
    <FormError error={error} errorField='email' />
  </Form>
);
